import { IIndex } from '../interfaces/IIndex'

export const indexesConfig: Array<IIndex> = [
  { name: 'S&P 500' },
  { name: 'NDX' },
  { name: 'DJIA' },
  { name: 'RUT' },
]
